import { ModeloPersonalizadoRelatorioGerencial, TipoModuloEnum } from 'graphql/types.generated'
import { useEffect, useRef } from 'react'
import { useField, useForm } from 'react-final-form'
import { Permission } from 'types/Permissions.generated'
import { metaPath } from 'util/metaPath'

import { KeyMapping } from '../../common/keyMapping-relatorioGerencial'
import { modeloPersonalizadoToFiltrosFormModel } from '../modelo-personalizado/converter-modeloPersonalizadoRelatorioGerencial'
import { ModeloPersonalizadoModel } from '../modelo-personalizado/model-modeloPersonalizado'
import { RelatorioGerencialFiltrosFormModel } from './model-relatorioGerencialFiltrosForm'

const meta = metaPath<RelatorioGerencialFiltrosFormModel>()

export interface AplicarModeloPersonalizadoCarregadoProps {
  modeloCarregado: ModeloPersonalizadoRelatorioGerencial
  keyMapping: Map<string, KeyMapping>
  modulo: TipoModuloEnum
  isGestorEstadual: boolean
  hasFiltroPeriodo: boolean
  hasFiltroTipoAgrupamento: boolean
  hasAuthorization: (permission: Permission) => boolean
}

export function AplicarModeloPersonalizadoCarregado(props: AplicarModeloPersonalizadoCarregadoProps) {
  const {
    modeloCarregado,
    keyMapping,
    modulo,
    isGestorEstadual,
    hasFiltroPeriodo,
    hasFiltroTipoAgrupamento,
    hasAuthorization,
  } = props

  const form = useForm<RelatorioGerencialFiltrosFormModel>()
  const {
    input: { value: modeloSelecionado },
  } = useField<ModeloPersonalizadoModel>(meta.modeloPersonalizado.absolutePath(), { subscription: { value: true } })

  const modeloSelecionadoId = modeloSelecionado?.id
  const modeloAplicadoRef = useRef<ModeloPersonalizadoRelatorioGerencial>(null)

  useEffect(() => {
    if (!modeloSelecionadoId) {
      modeloAplicadoRef.current = null
      return
    }

    const isCarregadoOSelecionado = modeloCarregado?.id === modeloSelecionadoId
    const jaFoiAplicado = modeloAplicadoRef.current === modeloCarregado

    if (!isCarregadoOSelecionado || jaFoiAplicado) return

    modeloAplicadoRef.current = modeloCarregado

    const filtros = modeloPersonalizadoToFiltrosFormModel(
      modeloCarregado,
      keyMapping,
      modulo,
      isGestorEstadual,
      hasFiltroPeriodo,
      hasFiltroTipoAgrupamento,
      hasAuthorization
    )

    form.batch(() =>
      Object.entries(filtros).forEach(([campo, valor]) =>
        form.change(campo as keyof RelatorioGerencialFiltrosFormModel, valor)
      )
    )
  }, [
    form,
    hasAuthorization,
    hasFiltroPeriodo,
    hasFiltroTipoAgrupamento,
    isGestorEstadual,
    keyMapping,
    modeloCarregado,
    modeloSelecionadoId,
    modulo,
  ])

  return null
}
